<hr />
<form-row>
  <button color="primary" mat-button matStepperPrevious *ngIf="!isStart">Zurück</button>
  <button color="primary" mat-button matStepperNext (click)="next()" *ngIf="!isEnd">Weiter</button>
  <button color="primary" mat-button *ngIf="isEnd" (click)="submit()">{{ submitButtonLabel }}</button>
</form-row>
